import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import moment from "moment";
import api from "../../../utils/api";
import close_modal from "./../../../assets/ic_close_wh.svg";
import Spinner from "../../../common/Spinner/Spinner";

export default function LPMStatusLogModel(props) 
{
    const [auditLog,setAuditLog] = useState([]);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if(props.isOpen)
        {
            if(props.nResourceInstanceId)
            {
                setLoading(true);
                let payload={nResourceInstanceId:props.nResourceInstanceId};
                api.getStateAuditLog(props.nResourceInstanceId)
                .then((d) => {
                    setAuditLog(d.data);
                    setLoading(false);
                });
            }            
        }        
      }, [props.isOpen]);

      const renderAuditTrail = () => {
        return auditLog.map((audit,i) => {
          return(
            <div className={`${i%2==0?'notes-trail-box-even':'notes-trail-box-odd'}`} key={i}>
                <div className="flex justify-content-between">
                    <small className="notes-trail-text">{audit.reqUser}</small>
                <small className="notes-trail-text">{moment(audit.dtCreated).format('lll')}</small>
                </div>
                <div className="conv-mt15">
                    <div><small className="notes-trail-text">State</small></div>
                    <div className="notes-trail-content-text conv-mt5" style={{whiteSpace: "pre-line"}}>
                        {audit.refSRState}
                    </div>   
                </div>
            </div>
          )
        })
      }

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.toggleModal}
      ariaHideApp={false}
    >
      <ModalContent className="lpm-notes-trail-modal">
          <div className="modal-header">
          <span className="modal-title">Status Log</span>
            <img
                alt="close"
                id="Close"
                src={close_modal}
                className="close modal-close"
                onClick={props.toggleModal}
            />
          </div>
        
        <div className={`modal-body notes-trail-content conv-pl25 conv-pr25 custom-scrollbar ${isLoading && "set-opacity"}`}>
            {isLoading && <Spinner className="top"/>}
            <div className="conv-mt10">                
                {auditLog.length>0?renderAuditTrail():<div className="notes-trail-box-even">No Log</div>}
            </div>
        </div>
      </ModalContent>
    </Modal>
  );
}